import styled from 'styled-components';
import { fontSizes, tableCellColor, tableHeaderCellColor } from '../constants/globalstyles';
import { Table as SemanticTable } from 'semantic-ui-react';

export const Table = styled(SemanticTable)<{
  selectable?: boolean;
}>`
  && {
    border: 1px solid #d4d4d5;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    selectable: ${props => (props.selectable ? 'true' : 'false')} !important;
    ${props =>
      props.selectable
        ? `
        &:hover {
          cursor: pointer !important;
        }`
        : ''};
  }
`;

export const TableHeader = styled(SemanticTable.Header)`
  && {
    padding: 0px 10px 2px 10px;
    margin-bottom: 5px;
  }
`;

export const HeaderCell = styled(SemanticTable.HeaderCell)<{
  selectable?: boolean;
  fontSize?: string;
  justify?: 'left' | 'right' | 'center';
}>`
  && {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    font-family: 'Poppins';
    font-weight: 500;
    font-size: ${props => (props.fontSize ? props.fontSize : fontSizes.medium)};
    text-align: ${props => props.justify || 'left'} !important;
    color: ${tableHeaderCellColor} !important;

    ${props =>
      props.selectable
        ? `
        &:hover {
          cursor: pointer !important;
        }`
        : ''};
  }
`;

export const TableBody = styled(SemanticTable.Body)``;

export const TableRow = styled(SemanticTable.Row)<{
  $selectable?: boolean;
  height?: string;
}>`
  height: ${props => props.height || 'auto'};

  transition: background-color 0.3s ease;

  ${props =>
    props.$selectable
      ? `
        &:hover {
          background-color: #f0f8ff !important;
          cursor: pointer !important;
        }`
      : ''};
`;

export const TableCell = styled(SemanticTable.Cell)<{
  $firstcol?: boolean;
  width?: number;
  justify?: 'left' | 'right' | 'center';
  bold?: boolean;
  color?: string;
  backgroundColor?: string;
  fontSize?: string;
}>`
  && {
    font-family: 'Poppins', sans-serif;
    padding: 10px !important;
    padding-left: ${props => (props.$firstcol ? '15px' : '10px')} !important;
    font-weight: ${props => (props.bold ? 600 : props.$firstcol ? 500 : 400)};
    font-size: ${props => props.fontSize || (props.$firstcol ? '14px' : '12px')};
    color: ${props => props.color || tableCellColor};
    background-color: ${props => props.backgroundColor || 'transparent'} !important;
    text-align: ${props => props.justify || 'left'} !important;
  }
`;
